module.exports = __webpack_public_path__ + "img/zhishi.57826585.png";